// extracted by mini-css-extract-plugin
module.exports = {"container":"product-ui-toggle_container__wkkIG","hover":"product-ui-toggle_hover__BpHFO","selected":"product-ui-toggle_selected__ZmU2C","toggle":"product-ui-toggle_toggle__7UMBa"};